import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import { useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Point(_ref) {
  var {
    style,
    title,
    checked,
    color,
    onClick,
    rectProps
  } = _ref;
  var btn = useRef(null);
  var handleMouseEnter = useCallback(() => {
    btn.current.style['zIndex'] = '2';
    btn.current.style['outline'] = '#fff solid 2px';
    btn.current.style['boxShadow'] = 'rgb(0 0 0 / 25%) 0 0 5px 2px';
  }, []);
  var handleMouseLeave = useCallback(() => {
    if (!checked) {
      btn.current.style['zIndex'] = '0';
      btn.current.style['outline'] = 'initial';
      btn.current.style['boxShadow'] = 'initial';
    }
  }, [checked]);
  return /*#__PURE__*/_jsx("div", _extends({
    ref: btn,
    title: title
  }, rectProps, {
    onClick: onClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    style: _extends({}, style, {
      marginRight: 0,
      marginBottom: 0,
      borderRadius: 0,
      boxSizing: 'border-box',
      height: 25,
      width: 25
    }, checked ? {
      zIndex: 1,
      outline: '#fff solid 2px',
      boxShadow: 'rgb(0 0 0 / 25%) 0 0 5px 2px'
    } : {
      zIndex: 0
    }, rectProps.style)
  }));
}